// change this everytime redux storage structure changes
export function version() {
  return 'v1.2.6';
}
